import { Questionnaire } from '../lead-manage-questionnaires/lead-manage-questionnaires.types';

export interface Participant {
  name: string;
  role: string;
}

export interface i18nField {
  de: string;
  en: string;
}

export interface i18nQuestion {
  selfAssessment: i18nField;
  externalAssessment: i18nField;
}

export interface i18nEffectSubCategory {
  name: i18nField;
  questions: i18nQuestion[];
}

export interface i18nClosedSubCategory {
  name: i18nField;
  description: i18nField;
  questions: i18nQuestion[];
}

export enum QuestionnaireLanguages {
  DE = 'de',
  EN = 'en',
}

export interface AddParticipantsDialogState {
  open: boolean;
  participants: Participant[];
  questionnaire?: Questionnaire;
}

export interface AddNewClosedQuestionDialogState {
  open: boolean;
  categoryName: i18nField;
  categoryInstructionSelf: i18nField;
  categoryInstructionExternal: i18nField;
  subCategories: i18nClosedSubCategory[];
}

export interface AddDimensionDialogState {
  open: boolean;
  categoryId?: string;
  name: i18nField;
  description: i18nField;
  questions: i18nQuestion[];
}

export interface AddNewEffectQuestionsDialogState {
  open: boolean;
  subCategories: i18nEffectSubCategory[];
}

export interface AddNewOpenQuestionsDialogState {
  open: boolean;
  questions: i18nQuestion[];
}

export interface AddQuestionDialogState {
  open: boolean;
  selfAssessment: i18nField;
  externalAssessment: i18nField;
  categoryId?: string;
  categorySourceId?: string;
  subCategoryId: string;
  subCategorySourceId?: string;
}

export interface ConfirmDeleteLeadQuestionDialog {
  open: boolean;
  questionId: string;
}

export interface ConfirmDeleteLeadCategoryDialog {
  open: boolean;
  categoryId: string;
}

export interface CreateQuestionnaireDialogState {
  open: boolean;
  name: string;
}

export interface DuplicateQuestionnaireDialogState {
  open: boolean;
  name: string;
}

export interface ResParticipant {
  id: string;
  completed: boolean;
  isSuspended: boolean;
  name: string;
  createdAt: string;
  updatedAt: string;
  perspective: string;
}

interface Question {
  id: string;
  sourceId: string;
  selfAssessment: i18nField;
  externalAssessment: i18nField;
}

interface SubCategory {
  id: string;
  sourceId: string;
  name: i18nField;
  questions: Question[];
}

export interface ClosedQuestion {
  id: string;
  sourceId: string;
  name: i18nField;
  externalIntroduction?: i18nField;
  selfIntroduction?: i18nField;
  subCategories: SubCategory[];
}

export interface EffectQuestion {
  id: string;
  sourceId: string;
  name: i18nField;
  questions: Question[];
}

export interface OpenQuestion {
  id: string;
  sourceId: string;
  selfAssessment: i18nField;
  externalAssessment: i18nField;
  suggestion: boolean;
}

export interface DetailResponse {
  id: string;
  recordOwner: string;
  completed: boolean;
  name: string;
  createdAt: string;
  updatedAt: string;
  folder: string;
  participants: ResParticipant[];
  closedQuestions: ClosedQuestion[];
  openQuestions: OpenQuestion[];
  effectQuestions: EffectQuestion[];
}

interface SubCategoryPayload {
  name: i18nField;
  description: i18nField;
  questions: i18nQuestion[];
}

interface ExtendSubCategoryPayload {
  id: string;
  questions: i18nQuestion[];
}

export interface CreateClosedQuestionPayload {
  name: i18nField;
  selfIntroduction: i18nField;
  externalIntroduction: i18nField;
  subCategories: SubCategoryPayload[];
}

export interface ExtendClosedQuestionPayload {
  id: string;
  subCategories: SubCategoryPayload[];
}

export interface ExtendEffectQuestionPayload {
  name: i18nField;
  questions: i18nQuestion[];
}

export interface AddClosedDimensionQuestionPayload {
  id: string;
  subCategories: ExtendSubCategoryPayload[];
}

export interface AddEffectDimensionQuestionPayload {
  id: string;
  questions: i18nQuestion[];
}

export interface CreateEffectQuestionPayload {
  name: i18nField;
  questions: i18nQuestion[];
}
